define(["./monitoringDeliveryOverviewModule", "json!../tdnByEntity.json"], function (module, tdnByEntity) {
    "use strict";

    return module.controller("monitoringDeliveryOverviewController", [
        "$scope",
        "$q",
        "monitoringService",
        "loadingService",
        "remoteExceptionHandler",
        "modalSubtitles",
        "$filter",
        "$translate",
        "monitoringDeliveryOverviewDetailsModal",
        "filteredMonitorables",
        "monitorableMapViewModal",
        "tdnHelp",
        function ($scope, $q, monitoringService, loadingService, remoteExceptionHandler, modalSubtitles, $filter, $translate, monitoringDeliveryOveerviewDetailsModal, filteredMonitorables, monitorableMapViewModal, tdnHelp) {
            $scope.tdn = tdnByEntity?.[tdnHelp.getContext()]?.["monitorable-delivery-overview"];

            $scope.serviceName = monitoringService.getMonitoringDeliveryOverviewFilterUrl();
            $scope.isActiveSummaryPerPage = true;
            let page = 1;
            let firstPage = 1
            let template = [], paginationApi, paginationApiDefer = $q.defer();
            let filterApi, filterApiDefer = $q.defer();

            $scope.openModalSubtitles = () => {
                modalSubtitles()
            }

            $scope.search = function (modifiedTemplate) {
                template = modifiedTemplate;
                paginationApi.seekPage(firstPage);
            };

            $scope.onRegisterFilterApi = function (api) {
                filterApi = api;
                filterApiDefer.resolve();
            };

            $scope.preSelectedFilters = getPreSelectedFilters(filteredMonitorables)

            function getPreSelectedFilters(filteredMonitorables) {
                if (!filteredMonitorables.length) {
                    return null
                }
                const timestamps = filteredMonitorables.map(monitorable => new Date(monitorable.creationTimestamp).getTime());
                const betweenCreationDates = getCreationDatesBetween(timestamps);

                const now = Date.now();
                const sevenDaysLater = now + (7 * 24 * 60 * 60 * 1000);
                const timestampArray = [now, sevenDaysLater];

                return [
                    {
                        "persistentFieldName": "monitorable.creationTimestamp",
                        "restFieldName": "monitorable.creationTimestamp",
                        "filterType": {
                            "filterTypeName": "date",
                            "defaultOperations": [
                                "br.com.neolog.webfilter.FilterOperation.BETWEEN"
                            ]
                        },
                        "required": true,
                        "defaultFilterValue": null,
                        "defaultMultipleValue": timestampArray,
                        "fieldName": "monitorable.creationTimestamp",
                        "operation": "br.com.neolog.webfilter.FilterOperation.BETWEEN",
                        "multipleValue": betweenCreationDates
                    },
                    {
                        "persistentFieldName": "monitorable.sourceId",
                        "restFieldName": "monitorable.sourceId",
                        "filterType": {
                            "filterTypeName": "text",
                            "defaultOperations": [
                                "br.com.neolog.webfilter.FilterOperation.EQUAL",
                                "br.com.neolog.webfilter.FilterOperation.IN",
                                "br.com.neolog.webfilter.FilterOperation.LIKE",
                                "br.com.neolog.webfilter.FilterOperation.LIKE_IN"
                            ]
                        },
                        "required": false,
                        "defaultFilterValue": null,
                        "defaultMultipleValue": null,
                        "fieldName": "monitorable.sourceId",
                        "operation": "br.com.neolog.webfilter.FilterOperation.IN",
                        "multipleValue": filteredMonitorables.map(monitorable => monitorable.sourceId)
                    }]
            }

            function getCreationDatesBetween(timestamps) {
                const minTimestamp = Math.min(...timestamps);
                const maxTimestamp = Math.max(...timestamps);

                const minDate = new Date(minTimestamp);
                minDate.setDate(minDate.getDate() - 1);
                minDate.setHours(0, 0, 0, 0);
                const maxDate = new Date(maxTimestamp);
                maxDate.setDate(maxDate.getDate() + 1);
                maxDate.setHours(23, 59, 0, 0);

                const formattedMinDate = minDate.toISOString();
                const formattedMaxDate = maxDate.toISOString();
                return [formattedMinDate, formattedMaxDate];
            }

            $q.all([paginationApiDefer.promise, filterApiDefer.promise]).then(function () {
                filterApi.onChangeService(function () {
                    if (filteredMonitorables.length) {
                        filterApi.search();
                    }
                });
            });


            $scope.summary = {
                total: 0, delivered: 0, notAccomplished: 0, pending: 0, occurrences: 0, finalizedDestination: 0, totalDestination: 0
            };

            $scope.tableOptions = {
                records: [], pagination: {
                    maxPageSize: 10, onPaginate: function (firstResult, maxResults) {
                        page = $scope.tableOptions.pagination.currentPage;
                        return loadingService(monitoringService.filterMonitoringDelivery(template, firstResult, maxResults))
                            .then(function (response) {
                                $scope.summary = response.result[0]["summary"]
                                $scope.totalSummary = response.result[0]["totalSummary"]
                                response.result = response.result[0]["results"];
                                $scope.isActiveSummaryPerPage = true;
                                return response;
                            }).catch(remoteExceptionHandler());
                    }
                }, onRegisterPagination: function (api) {
                    paginationApi = api;
                    paginationApiDefer.resolve();
                }
            };

            $scope.getNumberClass = (number) => {
                if (number >= 100) {
                    return "more-than-hundred"
                }
            }

            $scope.getStatusClass = (stop) => {
                return getAcronymLogisticRule(stop.logisticRule) + "_" + getStatusType(stop).toLowerCase();
            }

            function getAcronymLogisticRule(logisticRule) {
                if (logisticRule === "br.com.neolog.monitoring.overview.delivery.DeliveryOverviewLocalityType.LOAD") {
                    return "load";
                }
                if (logisticRule === "br.com.neolog.monitoring.overview.delivery.DeliveryOverviewLocalityType.UNLOAD") {
                    return "unload";
                }
                if (logisticRule === "br.com.neolog.monitoring.overview.delivery.DeliveryOverviewLocalityType.BOTH") {
                    return "both";
                }
                return "origin";
            }

            function getStatusType(stop) {
                let lastDotIndex = stop.statusType.lastIndexOf(".");
                return stop.statusType.substring(lastDotIndex + 1);
            }

            $scope.getTooltipMessage = (stop) => {
                let statusType = getStatusType(stop);
                if (statusType === "ORIGIN") {
                    return $translate.instant("monitoring.delivery.overview.message.origin.estimated.timestamp") + getDateOrNA(stop.currentEstimatedTimestamp);
                }
                if (statusType === "ORIGIN_FINALIZED") {
                    return $translate.instant("monitoring.delivery.overview.message.origin.finalized.timestamp") + getDateOrNA(stop.lastFinalizedTimestamp);
                }

                if (stop.lastFinalizedTimestamp) {
                    return $translate.instant("monitoring.delivery.overview.message.finalized.timestamp") + getDateOrNA(stop.lastFinalizedTimestamp);
                }
            }

            function getDateOrNA(dateTime) {
                if (!dateTime) {
                    return "N/A"
                }
                let dateFilter = $filter("date");
                return dateFilter(dateTime, "short");
            }

            $scope.openInvoiceDetailsModal = function (details, sequenceOnTrip, logisticRule) {
                return monitoringDeliveryOveerviewDetailsModal(details, sequenceOnTrip, logisticRule);
            }

            $scope.getTripStatusTooltip = (monitorableTripstatusImage) => {
                if (monitorableTripstatusImage.includes("DELAYED")) {
                    return "monitoring.delivery.overview.message.status.delayed"
                }
                if (monitorableTripstatusImage.includes("IN_TIME")) {
                    return "monitoring.delivery.overview.message.status.in_time"
                }
                if (monitorableTripstatusImage.includes("WARNING")) {
                    return "monitoring.delivery.overview.message.status.warning"
                }
            }

            $scope.openRouteModal = (record) => {
                return loadingService(monitoringService.findMonitorableAssociatedTransitionGroupWithSameLocality(record.monitorableId))
                    .then((monitorable) => monitorableMapViewModal(monitorable));
            }

            $scope.getAccomplishedStops = (isActiveSummaryPerPage) => {
                if (isActiveSummaryPerPage) {
                    return $scope.summary.finalizedDestination + "/" + $scope.summary.totalDestination
                }
                return $scope.totalSummary.finalizedDestination + "/" + $scope.totalSummary.totalDestination
            }
        }]);
});
